import { ValueOf } from 'type-fest';
import { getEnvVar } from '../../../utils/env';

export const DEFAULT_RAILS_REALM_ID = getEnvVar('UI_ENV') || '';
export const DEFAULT_REALM_NAME = getEnvVar('UI_ENV') || '';

export enum RealmTypes {
  sandbox = 'Sandbox', // Matching glx server values
  subscription = 'Subscription',
}

export type RealmTypesValues = ValueOf<typeof RealmTypes>;

export const realmTypeConfigs = {
  [RealmTypes.sandbox]: {
    value: RealmTypes.sandbox,
    label: 'Sandbox',
  },
  [RealmTypes.subscription]: {
    value: RealmTypes.subscription,
    label: 'Subscription',
  },
} as const;

export enum RealmTableView {
  Active = 'Active',
  Archived = 'Archived',
}

// for both subscription and sandbox
export const DEFAULT_REALM_TABLE_VIEW = RealmTableView.Active;

export const REALM_TABLE_VIEW_ARRAY = [
  {
    label: 'Active',
    value: RealmTableView.Active,
  },
  {
    label: 'Archived',
    value: RealmTableView.Archived,
  },
];
